import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import AuthPanel from './components/Panel';
import AuthPanelCESUpgradeMessage from './components/content/AuthPanelCESUpgradeMessage';
import AuthScreenLayout from '../../components/AuthScreenLayout';
import { registerState } from '../../../../common/Services/RegistrationService.js';
import AuthPanelActions from './redux/actions';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const namespace = 'authPanel';

import reducer from './redux/reducer';
import saga from './redux/sagas';

const store = getStore();

const createAuthScreen = ({
  userFieldName,
  userFieldValue,

  passwordFieldName,
  passwordFieldValue,

  rememberMeFieldName,
  rememberMeFieldValue,

  totpCodeFieldName,
  totpCodeFieldValue,

  cesMigrated,
  cesSupportUrl,
}) => {
  const domId = 'authPanel';
  if (isSupportedBrowser()) {
    registerState({
      namespace,
      reducers: reducer,
      sagas:    [saga],
    });
    store.dispatch(
      AuthPanelActions.bootstrap(
        userFieldName,
        userFieldValue,
        passwordFieldName,
        passwordFieldValue,
        rememberMeFieldName,
        rememberMeFieldValue,
        totpCodeFieldName,
        totpCodeFieldValue,
        cesSupportUrl
      )
    );
    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <Choose>
            <When condition={!!cesMigrated}>
              <AuthPanelCESUpgradeMessage />
            </When>
            <Otherwise>
              <AuthPanel />
            </Otherwise>
          </Choose>
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createAuthScreen = createAuthScreen;
export { namespace };
